// import { Link } from "react-router-dom"
import "./Home.css"
import dhinesh from "./dhinesh.jpeg"
// import aos from "aos"

const Home = ()=>
{
    return(
        <div className="home">
            <div className="homeone" data-aos="fade-down">
                <h1>I'm Dhinesh kumar k</h1>
                <p>This is my personal portfolio website showcasing my technical skills, projects, and professional experience .</p>
                <button><a href="/dhineshResumelatest (1).pdf" target="_blank" rel="noopener noreferrer">Resume</a></button>
                <div className="icons">
                    <a href="https://github.com/DHINESHKUMAR2305" target="new"><i class="fa-brands fa-github"></i></a>
                    <a href="https://www.linkedin.com/in/dhineshkandhasamy/" target="new"><i class="fa-brands fa-linkedin"></i></a>
                </div>
            </div>
            <div className="hometwo">
                <img src={dhinesh} alt="" />
            </div>
        </div>
    )
}

export default Home